// Module 15's sidebar contribution (contract 15 §11/§12, v3 `components/Layouts/DefaultLayout.vue`).
//
// v3 ships an "Insights" leaf as the FIRST child of the Cockpit group — the group v4 composes as
// `cockpit` in `app/navigation/registerShellNavigation.ts`, alongside Alerts, Anomalies and
// Health Checks. So unlike module 24's User Behavior leaf (see `features/audience/nav.ts`, which
// v3 comments out and v4 therefore withholds), this leaf EXISTS in v3 and its absence in v4 was a
// straightforward gap — ORP-20390.
//
// ══ THE GATE ════════════════════════════════════════════════════════════════════════════════
// v3 gated the leaf on the `recommendations` PERMISSION. That permission is dead: ledger B24
// (RESOLVED 2026-07-31, product owner) records that the backend Recommendations feature was
// removed wholesale (ORP-18021) and the leftover FE check gates nothing. B24 ratifies exactly one
// v4 gate for the insights surface — the workspace `insights` feature flag OR sysadmin — and
// contract 15 §12 (ORP-18734 R6) requires it on **route and nav**, closing v3's open URL.
//
// The route half already shipped (`components/display/InsightsRoute.vue` redirects a denied user
// to Summary). This file is the nav half, and it is deliberately the SAME predicate rather than a
// second one: `useInsightsRbac().canViewInsights` is `isSysAdmin || checkFlag('insights')`, which
// the nav model expresses as the `multiple` (OR) rule below — the identical shape module 09's
// Orpheus leaf uses. Feature code cannot hand a composable to the nav engine (the engine is pure
// and evaluates rules itself), so the predicate is mirrored structurally, not imported. It widens
// nothing: `AppTopbar.vue`'s insights panel is already shown on this exact condition.
//
// No `meta` search payload — v3's entry carries neither `search_value` nor `importance`.

import { INSIGHTS_PREVIEW_ROUTE } from './routes'

export const insightNavItems = [
  {
    labelKey: 'insights.nav.label',
    navKey: 'insights',
    // Route NAME, not path: the leaf survived the record's move from `insights-v4` to `/insights`
    // (ORP-20404) untouched — which is the point of targeting by name.
    to: INSIGHTS_PREVIEW_ROUTE,
    visibility: {
      control: 'multiple' as const,
      id: [{ control: 'flag', id: 'insights' }, { control: 'sysAdmin' }],
    },
  },
]
